import { Component, EventEmitter, OnInit, OnDestroy, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'cv-queue-searchbar',
    templateUrl: './queue-searchbar.component.html',
    styleUrls: ['./queue-searchbar.component.scss'],
})
export class QueueSearchbarComponent implements OnInit, OnDestroy {
    @Output() searchQueryEmitter = new EventEmitter<string>();
    @Output() onEnterPressed = new EventEmitter<void>();
    @Input() placeholder = 'Search';

    searchControl = new FormControl('');

    private textSubscription!: Subscription;

    ngOnInit() {
        this.textSubscription = this.searchControl.valueChanges
            .pipe(
                debounceTime(800),
                distinctUntilChanged(),
            )
            .subscribe((value) => {
                if(value !== undefined && value !== null){
                    this.searchQueryEmitter.emit(value);
                }
            });
    }

    ngOnDestroy() {
        this.textSubscription.unsubscribe();
    }

    /**
     * Handles the enter event
     * @param {KeyboardEvent} event 
     */
    public onKeyPress(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.onEnterPressed.emit();
        }
    }
}
